// Types
import {amount as amountType} from '@drivesally/sally-fn/lib/types';

export const raw = ({transaction: {amount = 0} = {}} = {}) =>
  amountType(amount).format();

export default (args) => `$${amountType(raw(args)).format()}`;
